import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI, responsaveisEtapas, MidiasContato, tiposMensagem, momentosEnvio, destinatariosMensagem } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash, FaQuestionCircle, FaStream, FaSearch, FaArrowUp, FaArrowDown } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class EtapasPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            etapas: [],
            etapaSelecionada: [{ 
                nome: '', dias_proxima_etapa: '', formulario_id: '', descricao: '', 
                formulario_nome: '', formulario_pesquisa_id: '', formulario_pesquisa_nome: '', responsavel_etapa: '', ocultar_etapa: [], midias_contato: [], 
                tipo_mensagem: [], whatsapp_template: '', tipo_envio: '', momento_envio: '', 
                etapa_termo: '', etapa_pesquisa: '', etapa_pesquisa_id: null, acao_navegador_apos_prazo: '', prazo_acao_navegador: '', 
                etapa_nota_fiscal: '', conteudo_mensagem: '', conteudo_mensagem_email: '', 
                destinatario_mensagem: '', id: null, titulo_sucesso_finalizacao: '', 
                mensagem_sucesso_finalizacao: '', cancelamento_whatsapp_template: '', 
                cancelamento_titulo_email: '', cancelamento_conteudo_mensagem: '', 
                cancelamento_conteudo_mensagem_email: '', cancelamento_destinatario_mensagem: '', 
                cancelamento_retorno_whatsapp_template: '', cancelamento_retorno_titulo_email: '', 
                cancelamento_retorno_conteudo_mensagem: '', cancelamento_retorno_conteudo_mensagem_email: '', 
                cancelamento_retorno_destinatario_mensagem: '', servicos_procedimentos: [], 
                isServicosFocused: false, opcoesServicos: [], servicos_relacionados_bool: false, etapa_tipo_paciente: '',
                servico_obrigatorio: false, servico_fixo: false, alerta_navegador: '', status_finalizacao_etapa_id: "",
                avancar_etapa_automaticamente: '', dias_envio_mensageria: '', envia_mensageria_cron: '',
                focusServicosProcedimentos: false, servicosProcedimentosSearchTimeout: null
            }],
            programa_id: this.props.programa_id,
            status_programa: this.props.status_programa,
            erroLoadRegistro: '',
            loading: true,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 50
        }
    }

    componentDidMount() {
        this.carregarEtapasPrograma();
    }

    carregarEtapasPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/etapas/?programa_id=${this.state.programa_id}&status=1&page=${this.state.page_numb}&limit=${this.state.page_limit}`)
                .then(response => {                    
                    this.setState({
                        etapas: {
                            ...response.data,
                            results: response.data.results.map(etapa => ({
                                ...etapa,
                                id: etapa.id,
                                nome: etapa.nome,
                                descricao: etapa.descricao,
                                dias_proxima_etapa: etapa.dias_proxima_etapa,
                                formulario_id: etapa.formulario_id,
                                formulario_nome: etapa.dados_formulario.nome,
                                formulario_pesquisa_id: etapa.formulario_pesquisa_id,
                                formulario_pesquisa_nome: etapa.dados_formulario_pesquisa.nome,
                                responsavel_etapa: etapa.responsavel_etapa,
                                titulo_sucesso_finalizacao: etapa.titulo_sucesso_finalizacao,
                                mensagem_sucesso_finalizacao: etapa.mensagem_sucesso_finalizacao,
                                ocultar_etapa: etapa.ocultar_etapa ? etapa.ocultar_etapa.split(',') : [],
                                ordem: etapa.ordem,
                                midias_contato: etapa.midias_contato ? etapa.midias_contato.split(',') : [],
                                alerta_navegador: etapa.alerta_navegador,
                                conteudo_mensagem: etapa.conteudo_mensagem,
                                conteudo_mensagem_email: etapa.conteudo_mensagem_email,
                                tipo_envio: etapa.tipo_envio,
                                whatsapp_template: etapa.whatsapp_template,
                                momento_envio: etapa.momento_envio,
                                etapa_termo: etapa.etapa_termo,
                                etapa_pesquisa: etapa.etapa_pesquisa,
                                etapa_pesquisa_id: etapa.etapa_pesquisa ? etapa.etapa_pesquisa_id : null,
                                acao_navegador_apos_prazo : etapa.acao_navegador_apos_prazo,
                                avancar_etapa_automaticamente : etapa.avancar_etapa_automaticamente,
                                prazo_acao_navegador : etapa.prazo_acao_navegador,
                                dias_envio_mensageria : etapa.dias_envio_mensageria,
                                envia_mensageria_cron : etapa.envia_mensageria_cron,
                                etapa_nota_fiscal: etapa.etapa_nota_fiscal,
                                etapa_tipo_paciente: etapa.etapa_tipo_paciente,
                                destinatario_mensagem: etapa.destinatario_mensagem,
                                status_finalizacao_etapa_id: etapa.status_finalizacao_etapa_id,
                                // cancelamento
                                cancelamento_whatsapp_template: etapa.cancelamento_whatsapp_template,
                                cancelamento_titulo_email: etapa.cancelamento_titulo_email,
                                cancelamento_conteudo_mensagem: etapa.cancelamento_conteudo_mensagem,
                                cancelamento_conteudo_mensagem_email: etapa.cancelamento_conteudo_mensagem_email,
                                cancelamento_destinatario_mensagem: etapa.cancelamento_destinatario_mensagem,
                                // retorno
                                cancelamento_retorno_whatsapp_template: etapa.cancelamento_retorno_whatsapp_template,
                                cancelamento_retorno_titulo_email: etapa.cancelamento_retorno_titulo_email,
                                cancelamento_retorno_conteudo_mensagem: etapa.cancelamento_retorno_conteudo_mensagem,
                                cancelamento_retorno_conteudo_mensagem_email: etapa.cancelamento_retorno_conteudo_mensagem_email,
                                cancelamento_retorno_destinatario_mensagem: etapa.cancelamento_retorno_destinatario_mensagem,
                                // servicos
                                opcoesServicos: [],
                                servicos_relacionados_bool: etapa.servicos_relacionados,
                                servico_obrigatorio: etapa.servico_obrigatorio,
                                servico_fixo: etapa.servico_fixo,
                                servicos_procedimentos: etapa.dados_servicos_relacionados.map(servico => ({
                                    value: servico.servico_procedimento_id,
                                    label: servico.servico_procedimento__nome,
                                })),
                                focusFormularios: false,
                                formulariosSearchTimeout: false
                            }))
                        },
                        loading: false
                    }, () => {
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar etapas:', error);
                    
                    let erro_msg = 'Erro ao carregar etapas do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    handleEtapaChange = (e, campo) => {
        if (campo === 'formulario_id') {
            this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, formulario_id: e.value, formulario_nome: e.label } });
        } else if(campo === 'formulario_pesquisa_id') {
            this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, formulario_pesquisa_id: e.value, formulario_pesquisa_nome: e.label } });
        } else {
            const { name, value } = e.target;
            this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, [name]: value } });
        }
    }

    handleSimNaoChange = (event, fieldName) => {
        const { value } = event.target;
        
        this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, [fieldName]: value === "1" } });
    };

    handleEtapaChangeCheck = (isChecked, fieldName) => {
        const etapa = { ...this.state.etapaSelecionada, [fieldName]: isChecked };       
        this.setState({ etapaSelecionada: etapa, focusServicosProcedimentos: true});
    };
    
    handleEtapaServicoChange = (selectedOption) => {
        // Atualiza o serviço selecionado da etapa específica
        const updatedEtapas = {...this.state.etapaSelecionada};
        updatedEtapas.servicos_procedimentos = selectedOption;
        this.setState({ etapaSelecionada: updatedEtapas });
    };

    handleMidiasContatoChange = (midia, isChecked) => {
        let midiasContatoSet = new Set(this.state.etapaSelecionada.midias_contato);
    
        if (isChecked) {
            midiasContatoSet.add(midia);
        } else {
            midiasContatoSet.delete(midia);
        }
    
        this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, midias_contato: Array.from(midiasContatoSet) } });
    };

    handleTiposMensagemChange = (tipo) => {
        this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, tipo_mensagem: tipo } });
    };


    handleOcultarEtapaChange = (id, isChecked) => {
        let ocultarEtapasSet = new Set(this.state.etapaSelecionada.ocultar_etapa);
    
        if (isChecked) {
            ocultarEtapasSet.add(id);
        } else {
            ocultarEtapasSet.delete(id);
        }
    

        this.setState({ etapaSelecionada: { ...this.state.etapaSelecionada, ocultar_etapa: Array.from(ocultarEtapasSet) } });
    };

    moverEtapa = (index, direcao) => {
        let novasEtapas = [...this.state.etapas.results];
        let etapaMovida = { ...novasEtapas[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca a etapa atual com a anterior
            novasEtapas[index] = novasEtapas[index - 1];
            novasEtapas[index - 1] = etapaMovida;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novasEtapas[index].ordem = index + 1;
            novasEtapas[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novasEtapas.length - 1) {
            // Troca a etapa atual com a seguinte
            novasEtapas[index] = novasEtapas[index + 1];
            novasEtapas[index + 1] = etapaMovida;
            // Atualiza a ordem
            novasEtapas[index].ordem = index + 1;
            novasEtapas[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ etapas: { ...this.state.etapas, results: novasEtapas } }, () => {
            // Salva a etapa movida com a nova ordem
            this.handleSalvarEtapa(index + (direcao === 'down' ? 1 : -1));
            // Salva a etapa que foi substituída pela movida, para atualizar sua ordem
            this.handleSalvarEtapa(index);
        });
    };
    
    handleSalvarEtapa = async (index = null) => {
        const etapa = index !== null ? this.state.etapas.results[index] : this.state.etapaSelecionada;
        let url = '';
        let metodo = '';
        if(index !== null){
            url = `/programas/etapas/${this.state.etapas.results[index].id}/`;    
            metodo = 'put';
        } else {
            url = etapa.id ? `/programas/etapas/${etapa.id}/` : '/programas/etapas/';
            metodo = etapa.id ? 'put' : 'post';
        }

        const midiasContatoString = (etapa.midias_contato) ? etapa.midias_contato.join(',') : '';
        const ocultarEtapaString = (etapa.ocultar_etapa) ? etapa.ocultar_etapa.join(',') : '';
        let servicos_ids = [];

        if(etapa.servicos_procedimentos){
            servicos_ids = etapa.servicos_procedimentos.map(item => item['value']);
        }
        
        const dadosEtapa = {
            nome: etapa.nome,
            descricao: etapa.descricao,
            alerta_navegador: etapa.alerta_navegador,
            dias_proxima_etapa: etapa.dias_proxima_etapa,
            programa_id: this.state.programa_id,
            formulario_id: etapa.formulario_id,
            servicos_relacionados: etapa.servicos_relacionados_bool,
            servico_obrigatorio: etapa.servico_obrigatorio,
            servico_fixo: etapa.servico_fixo,
            servicos_procedimentos: servicos_ids,
        };

        if(index){
            dadosEtapa['ordem'] = index + 1;
        } else {
            dadosEtapa['ordem'] = etapa.ordem || this.state.etapas.results.length + 1;
        }

        if(etapa.formulario_pesquisa_id) {
            dadosEtapa['formulario_pesquisa_id'] = etapa.formulario_pesquisa_id;
        }

        if(etapa.conteudo_mensagem) {
            dadosEtapa['conteudo_mensagem'] = etapa.conteudo_mensagem; 
        } else {
            dadosEtapa['conteudo_mensagem'] = "";
        }
        if(etapa.conteudo_mensagem_email) {
            dadosEtapa['conteudo_mensagem_email'] = etapa.conteudo_mensagem_email; 
        } else {
            dadosEtapa['conteudo_mensagem_email'] = "";
        }
        if(etapa.tipo_envio) {
            dadosEtapa['tipo_envio'] = etapa.tipo_envio; 
        } else {
            dadosEtapa['tipo_envio'] = "";
        }
        if(etapa.whatsapp_template) {
            dadosEtapa['whatsapp_template'] = etapa.whatsapp_template; 
        } else {
            //dadosEtapa['whatsapp_template'] = "";
        }
        if(etapa.momento_envio) {
            dadosEtapa['momento_envio'] = etapa.momento_envio; 
        } else {
            dadosEtapa['momento_envio'] = "inicio";
        }
        if(etapa.etapa_termo) {
            dadosEtapa['etapa_termo'] = etapa.etapa_termo; 
        } else {
            dadosEtapa['etapa_termo'] = 0;
        }
        if(etapa.etapa_pesquisa) {
            dadosEtapa['etapa_pesquisa'] = etapa.etapa_pesquisa; 
        } else {
            dadosEtapa['etapa_pesquisa'] = 0;
        }
        if(etapa.etapa_pesquisa_id) {
            dadosEtapa['etapa_pesquisa_id'] = etapa.etapa_pesquisa_id; 
        } else {
            dadosEtapa['etapa_pesquisa_id'] = null;
        }
        if(etapa.acao_navegador_apos_prazo ) {
            dadosEtapa['acao_navegador_apos_prazo'] = etapa.acao_navegador_apos_prazo; 
        } else {
            dadosEtapa['acao_navegador_apos_prazo'] = 0;
        }
        if(etapa.avancar_etapa_automaticamente ) {
            dadosEtapa['avancar_etapa_automaticamente'] = etapa.avancar_etapa_automaticamente; 
        } else {
            dadosEtapa['avancar_etapa_automaticamente'] = 0;
        }
        if(etapa.prazo_acao_navegador ) {
            dadosEtapa['prazo_acao_navegador'] = etapa.prazo_acao_navegador; 
        } else {
            dadosEtapa['prazo_acao_navegador'] = 0;
        }
        if(etapa.dias_envio_mensageria ) {
            dadosEtapa['dias_envio_mensageria'] = etapa.dias_envio_mensageria; 
        } else {
            dadosEtapa['dias_envio_mensageria'] = 0;
        }
        if(etapa.envia_mensageria_cron ) {
            dadosEtapa['envia_mensageria_cron'] = etapa.envia_mensageria_cron; 
        } else {
            dadosEtapa['envia_mensageria_cron'] = 0;
        }
        if(etapa.status_finalizacao_etapa_id) {
            dadosEtapa['status_finalizacao_etapa_id'] = etapa.status_finalizacao_etapa_id; 
        } else {
            dadosEtapa['status_finalizacao_etapa_id'] = null; 
        }
        if(etapa.etapa_nota_fiscal) {
            dadosEtapa['etapa_nota_fiscal'] = etapa.etapa_nota_fiscal; 
        } else {
            dadosEtapa['etapa_nota_fiscal'] = 0;
        }
        if(etapa.etapa_tipo_paciente) {
            dadosEtapa['etapa_tipo_paciente'] = etapa.etapa_tipo_paciente; 
        } else {
            dadosEtapa['etapa_tipo_paciente'] = 0;
        }

        if(etapa.destinatario_mensagem) {
            dadosEtapa['destinatario_mensagem'] = etapa.destinatario_mensagem; 
        } else {
            dadosEtapa['destinatario_mensagem'] = "";
        }

        // cancelamento 
        if(etapa.cancelamento_whatsapp_template) {
            dadosEtapa['cancelamento_whatsapp_template'] = etapa.cancelamento_whatsapp_template; 
        } else {
            dadosEtapa['cancelamento_whatsapp_template'] = "";
        }
        if(etapa.cancelamento_titulo_email) {
            dadosEtapa['cancelamento_titulo_email'] = etapa.cancelamento_titulo_email; 
        } else {
            dadosEtapa['cancelamento_titulo_email'] = "";
        }
        if(etapa.cancelamento_conteudo_mensagem) {
            dadosEtapa['cancelamento_conteudo_mensagem'] = etapa.cancelamento_conteudo_mensagem; 
        } else {
            dadosEtapa['cancelamento_conteudo_mensagem'] = "";
        }
        if(etapa.cancelamento_conteudo_mensagem_email) {
            dadosEtapa['cancelamento_conteudo_mensagem_email'] = etapa.cancelamento_conteudo_mensagem_email; 
        } else {
            dadosEtapa['cancelamento_conteudo_mensagem_email'] = "";
        }
        if(etapa.cancelamento_destinatario_mensagem) {
            dadosEtapa['cancelamento_destinatario_mensagem'] = etapa.cancelamento_destinatario_mensagem; 
        } else {
            dadosEtapa['cancelamento_destinatario_mensagem'] = "";
        }
        // retorno
        if(etapa.cancelamento_retorno_whatsapp_template) {
            dadosEtapa['cancelamento_retorno_whatsapp_template'] = etapa.cancelamento_retorno_whatsapp_template; 
        } else {
            dadosEtapa['cancelamento_retorno_whatsapp_template'] = "";
        }
        if(etapa.cancelamento_retorno_titulo_email) {
            dadosEtapa['cancelamento_retorno_titulo_email'] = etapa.cancelamento_retorno_titulo_email; 
        } else {
            dadosEtapa['cancelamento_retorno_titulo_email'] = "";
        }
        if(etapa.cancelamento_retorno_conteudo_mensagem) {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem'] = etapa.cancelamento_retorno_conteudo_mensagem; 
        } else {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem'] = "";
        }
        if(etapa.cancelamento_retorno_conteudo_mensagem_email) {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem_email'] = etapa.cancelamento_retorno_conteudo_mensagem_email; 
        } else {
            dadosEtapa['cancelamento_retorno_conteudo_mensagem_email'] = "";
        }
        if(etapa.cancelamento_retorno_destinatario_mensagem) {
            dadosEtapa['cancelamento_retorno_destinatario_mensagem'] = etapa.cancelamento_retorno_destinatario_mensagem; 
        } else {
            dadosEtapa['cancelamento_retorno_destinatario_mensagem'] = "";
        }
        //
        if(midiasContatoString) {
            dadosEtapa['midias_contato'] = midiasContatoString; 
        } else {
            dadosEtapa['midias_contato'] = "";
        }

        if(etapa.responsavel_etapa) {
            dadosEtapa['responsavel_etapa'] = etapa.responsavel_etapa;
        }

        if(etapa.titulo_sucesso_finalizacao) {
            dadosEtapa['titulo_sucesso_finalizacao'] = etapa.titulo_sucesso_finalizacao;
        }

        if(etapa.mensagem_sucesso_finalizacao) {
            dadosEtapa['mensagem_sucesso_finalizacao'] = etapa.mensagem_sucesso_finalizacao;
        }

        if(ocultarEtapaString) {
            dadosEtapa['ocultar_etapa'] = ocultarEtapaString; 
        } 

        await api({
            method: metodo,
            url: url,
            data: dadosEtapa,
        })
        .then(response => {
            
            // Se for uma nova etapa, atualize o estado com a ID retornada pela API
            if(index == null){
                this.setState({ showModalEtapas: false });
                this.carregarEtapasPrograma();
                const MySwal = withReactContent(Swal)
                let textSwal = '';
                

                    textSwal = (etapa.id) ? 'Etapa atualizada com sucesso' : 'Etapa cadastrada com sucesso';

                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a etapa, verifique os campos e tente novamente';           
            let content = ''; 

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'descricao') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                    if(key == 'dias_proxima_etapa') {
                        content += `<br>&bull; Dias para Próxima Etapa: ${value}`;
                    }
                    if(key == 'formulario_id') {
                        content += `<br>&bull; Formulário: ${value}`;
                    }
                    if(key == 'alerta_navegador') {
                        content += `<br>&bull; Alerta Navegador: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content
            })
        });
    }

    removerEtapa = (etapa) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover etapa?',
            text: "Tem certeza que deseja remover a etapa #" + etapa.nome + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (etapa.id) {
                    const url = `/programas/etapas/${etapa.id}/`;
                    const metodo = 'put';
                
                    const dadosEtapa = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosEtapa,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Produto removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarEtapasPrograma();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o produto, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });
                }
            }
        });
    };

    handleShowModalEtapas = (etapa = []) => {
        this.setState({ showModalEtapas: true, etapaSelecionada: etapa }, () => {
            //console.log(this.state.etapaSelecionada);
        });
    }

    handleCloseModalEtapas = () => {
        this.setState({ showModalEtapas: false, etapaSelecionada: [] });
    }

    onClickPaginaEtapas = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarEtapasPrograma(num_page)
        });
    };

    carregarFormularios = async (inputValue, tipo = "formulario") => {
        if(tipo === "normal") {
            if(!this.state.focusFormularios) {
                return [];
            }
        } else if(tipo === "pesquisa") {
            if(!this.state.focusFormulariosPesquisa) {
                return [];
            }
        }
        try {
            const response = await api.get(`/formularios/?nome=${inputValue}&status=1&tipo=${tipo}`);
            const opcoes = response.data.results.map(formulario => ({
                value: formulario.id,
                label: formulario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };

    buscaServicosProcedimentos = async (inputValue = '') => {
        console.error("entrei aqui");
        // Verifica se a etapa foi focada antes de realizar a chamada
        if (!this.state.focusServicosProcedimentos) {
            return [];
        }
        try {
            // Ajusta a URL da API conforme a presença do inputValue
            const response = await api.get(`/programas/servicos_procedimentos/?programa=${this.state.programa_id}&status=1`);
            const opcoes = response.data.results.map(servico => ({
                value: servico.servico_procedimento_id,
                label: servico.dados_servico.nome,
            }));
            return opcoes;
        } catch (error) {
            console.error(error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao consultar serviços</p>,
            });
            return [];
        }
    };

    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Etapas do Programa</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalEtapas()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Etapa'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.etapas && this.state.etapas.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome</th>
                                            <th>Formulário</th>
                                            <th>Ordem</th>
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.etapas.results.map((etapa, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{etapa.id}</td>
                                                <td className="td-border">{etapa.nome}</td>
                                                <td className="td-border"><a href={`/formularios/edit/${etapa.formulario_id}`} target="_blank" rel="noopener noreferrer">{etapa.formulario_id ? etapa.formulario_nome : ''}</a></td>
                                                <td className="td-border">{etapa.ordem}
                                                    {etapa.id && index > 0 && (
                                                        <Button variant="outline-primary" className="btn-sm me-2" onClick={() => this.moverEtapa(index, 'up')}><FaArrowUp /></Button>
                                                    )}
                                                    {etapa.id && index < this.state.etapas.results.length - 1 && (
                                                        <Button variant="outline-primary" className="btn-sm" onClick={() => this.moverEtapa(index, 'down')}><FaArrowDown /></Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalEtapas(etapa)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerEtapa(etapa)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.etapas && this.state.etapas.results.length > 0 && (
                                        <Paginacao dados={this.state.etapas} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaEtapas} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhuma etapa cadastrada até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>
            {!this.state.loading && this.state.etapaSelecionada && (
            <Modal show={this.state.showModalEtapas} onHide={this.handleCloseModalEtapas} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.etapaSelecionada.id ? 'Editar Etapa #' + this.state.etapaSelecionada.id : 'Adicionar Etapa'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Card className="cardDestaque">
                            <Card.Body>
                                <h4>Etapa do Programa</h4>
                                        <Row>
                                            <Col sm={12}>
                                                <h4><strong>Etapa {this.state.etapaSelecionada.ordem}</strong></h4>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="nome" 
                                                        value={this.state.etapaSelecionada.nome} 
                                                        onChange={e => this.handleEtapaChange(e, 'nome')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Dias para Próxima Etapa</Form.Label>
                                                    <Form.Control 
                                                        type="number" 
                                                        name="dias_proxima_etapa" 
                                                        value={this.state.etapaSelecionada.dias_proxima_etapa} 
                                                        onChange={e => this.handleEtapaChange(e, 'dias_proxima_etapa')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Avançar Etapa Automaticamente?</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="avancar_etapa_automaticamente"
                                                        value={this.state.etapaSelecionada.avancar_etapa_automaticamente ? "1" : "0"}
                                                        onChange={e => this.handleEtapaChange(e, 'avancar_etapa_automaticamente')}
                                                    >
                                                        <option key="0" value="0">Não</option>
                                                        <option key="1" value="1">Sim</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Formulário</Form.Label>
                                                    <AsyncSelect
                                                        key={this.state.focusFormularios}
                                                        loadOptions={(inputValue) => {
                                                            return new Promise((resolve) => {
                                                                clearTimeout(this.formulariosSearchTimeout);
                                                                this.formulariosSearchTimeout = setTimeout(() => {
                                                                    resolve(this.carregarFormularios(inputValue, "normal"));
                                                                }, 700);
                                                            });
                                                        }}
                                                        onFocus={() => {
                                                            this.setState({
                                                                focusFormularios: true
                                                            });
                                                        }}
                                                        autoFocus={this.state.focusFormularios}
                                                        openMenuOnFocus={this.state.focusFormularios}
                                                        defaultOptions
                                                        name="formulario_id"
                                                        placeholder="Buscar formulário..."
                                                        noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                        onChange={e => this.handleEtapaChange(e, 'formulario_id')}
                                                        value={this.state.etapaSelecionada.formulario_id ? { value: this.state.etapaSelecionada.formulario_id, label: this.state.etapaSelecionada.formulario_nome } : null}
                                                    />
                                                    {this.state.etapaSelecionada.formulario_id && (
                                                        <ListGroup variant="light">   
                                                            <ListGroup.Item action href={`/formularios/edit/${this.state.etapaSelecionada.formulario_id}`} >
                                                                <FaSearch /> Ver Formulário
                                                            </ListGroup.Item>    
                                                        </ListGroup>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            {this.state.status_programa.length > 0 && (
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Status Vinculado ao Finalizar
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id="tooltip-explanation">
                                                                        Indica qual status deverá salvar o atendimento quando essa etapa for concluída.
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span style={{ cursor: 'pointer', marginLeft: '5px' }}>
                                                                    <FaQuestionCircle />
                                                                </span>
                                                            </OverlayTrigger>
                                                        </Form.Label>
                                                        <Form.Control as="select" name="status_finalizacao_etapa_id" value={this.state.etapaSelecionada.status_finalizacao_etapa_id} onChange={e => this.handleEtapaChange(e, 'status_finalizacao_etapa_id')}>
                                                            <option value="">Selecione um status</option>
                                                            {this.state.status_programa.map((status) => (
                                                                <option key={status.id} value={status.id}>{status.nome}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Formulário de Pesquisa</Form.Label>
                                                    <AsyncSelect
                                                        key={this.state.focusFormulariosPesquisa}
                                                        loadOptions={(inputValue) => {
                                                            return new Promise((resolve) => {
                                                                clearTimeout(this.formulariosPesquisaSearchTimeout);
                                                                this.formulariosPesquisaSearchTimeout = setTimeout(() => {
                                                                    resolve(this.carregarFormularios(inputValue, "pesquisa"));
                                                                }, 700);
                                                            });
                                                        }}
                                                        onFocus={() => {
                                                            this.setState({
                                                                focusFormulariosPesquisa: true
                                                            });
                                                        }}
                                                        autoFocus={this.state.focusFormulariosPesquisa}
                                                        openMenuOnFocus={this.state.focusFormulariosPesquisa}
                                                        defaultOptions
                                                        name="formulario_pesquisa_id"
                                                        placeholder="Buscar formulário de pesquisa..."
                                                        noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                        onChange={e => this.handleEtapaChange(e, 'formulario_pesquisa_id')}
                                                        value={this.state.etapaSelecionada.formulario_pesquisa_id ? { value: this.state.etapaSelecionada.formulario_pesquisa_id, label: this.state.etapaSelecionada.formulario_pesquisa_nome } : null}
                                                    />
                                                    {this.state.etapaSelecionada.formulario_pesquisa_id && (
                                                        <ListGroup variant="light">   
                                                            <ListGroup.Item action href={`/formularios/edit/${this.state.etapaSelecionada.formulario_pesquisa_id}`} >
                                                                <FaSearch /> Ver Formulário
                                                            </ListGroup.Item>    
                                                        </ListGroup>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Descrição</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        name="descricao" 
                                                        value={this.state.etapaSelecionada.descricao} 
                                                        onChange={e => this.handleEtapaChange(e, 'descricao')} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                        <Col sm={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige Ação do Navegador Após Prazo?</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="acao_navegador_apos_prazo"
                                                    value={this.state.etapaSelecionada.acao_navegador_apos_prazo ? "1" : "0"}
                                                    onChange={e => this.handleSimNaoChange(e, 'acao_navegador_apos_prazo')}
                                                >
                                                    <option key="0" value="0">Não</option>
                                                    <option key="1" value="1">Sim</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Prazo para Ação do Navegador (horas)</Form.Label>
                                                    <Form.Control type="number" name="prazo_acao_navegador" value={this.state.etapaSelecionada.prazo_acao_navegador} onChange={e => this.handleEtapaChange(e, 'prazo_acao_navegador')}>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>                                            
                                        <Row>
                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Responsável pelo Preenchimento</Form.Label>
                                                    <Form.Control as="select" name="responsavel_etapa" value={this.state.etapaSelecionada.responsavel_etapa} onChange={e => this.handleEtapaChange(e, 'responsavel_etapa')}>
                                                        <option value="">Selecione o responsável</option>
                                                        {responsaveisEtapas && Object.entries(responsaveisEtapas).map(([value, label]) => (
                                                            <option key={value} value={value}>{label}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Título de sucesso na finalização</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="titulo_sucesso_finalizacao" 
                                                        value={this.state.etapaSelecionada.titulo_sucesso_finalizacao} 
                                                        onChange={e => this.handleEtapaChange(e, 'titulo_sucesso_finalizacao')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Mensagem de sucesso na finalização</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="mensagem_sucesso_finalizacao" 
                                                        value={this.state.etapaSelecionada.mensagem_sucesso_finalizacao} 
                                                        onChange={e => this.handleEtapaChange(e, 'mensagem_sucesso_finalizacao')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Row>
                                                <Col sm={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Etapa de Termo?</Form.Label>
                                                        <Form.Control as="select" name="etapa_termo" value={(this.state.etapaSelecionada.etapa_termo) ? "1" : "0"} onChange={e => this.handleEtapaChange(e, 'etapa_termo')}>
                                                            <option key="0" value="0">Não</option>
                                                            <option key="1" value="1">Sim</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Etapa de Nota Fiscal?</Form.Label>
                                                        <Form.Control as="select" name="etapa_nota_fiscal" value={(this.state.etapaSelecionada.etapa_nota_fiscal) ? "1" : "0"} onChange={e => this.handleEtapaChange(e, 'etapa_nota_fiscal')}>
                                                            <option key="0" value="0">Não</option>
                                                            <option key="1" value="1">Sim</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Etapa de definição de tipo de paciente?</Form.Label>
                                                        <Form.Control as="select" name="etapa_tipo_paciente" value={(this.state.etapaSelecionada.etapa_tipo_paciente) ? "1" : "0"} onChange={e => this.handleEtapaChange(e, 'etapa_tipo_paciente')}>
                                                            <option key="0" value="0">Não</option>
                                                            <option key="1" value="1">Sim</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Serviços Disponíveis:</Form.Label>
                                                        
                                                        <Form.Check 
                                                            type="checkbox"
                                                            id={`servicos_relacionados_bool`}
                                                            name="servicos_relacionados_bool"
                                                            label="Habilitar serviços da etapa"
                                                            checked={this.state.etapaSelecionada.servicos_relacionados_bool ? this.state.etapaSelecionada.servicos_relacionados_bool : false}
                                                            onChange={e => this.handleEtapaChangeCheck(e.target.checked, 'servicos_relacionados_bool')}
                                                        />
                                                        {
                                                        this.state.etapaSelecionada.servicos_relacionados_bool &&
                                                        <>
                                                            <AsyncSelect
                                                                key={this.state.focusServicosProcedimentos}
                                                                loadOptions={(inputValue) => {
                                                                    return new Promise((resolve) => {
                                                                        clearTimeout(this.servicosProcedimentosSearchTimeout);
                                                                        this.servicosProcedimentosSearchTimeout = setTimeout(() => {
                                                                            resolve(this.buscaServicosProcedimentos(inputValue));
                                                                        }, 700);
                                                                    });
                                                                }}
                                                                onFocus={() => {
                                                                    this.setState({
                                                                        focusServicosProcedimentos: true
                                                                    });
                                                                }}
                                                                autoFocus={this.state.focusServicosProcedimentos}
                                                                openMenuOnFocus={this.state.focusServicosProcedimentos}
                                                                defaultOptions
                                                                onChange={(selectedOption) => this.handleEtapaServicoChange(selectedOption)} 
                                                                value={this.state.etapaSelecionada.servicos_procedimentos}
                                                                isMulti
                                                            />
                                                            <Row>
                                                                <Col sm={2}>
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        id={`servico_obrigatorio`}
                                                                        name="servico_obrigatorio"
                                                                        label="Obrigatório escolher serviço na etapa"
                                                                        checked={this.state.etapaSelecionada.servico_obrigatorio ? this.state.etapaSelecionada.servico_obrigatorio : false}
                                                                        className="mt-2"
                                                                        onChange={e => this.handleEtapaChangeCheck(e.target.checked, 'servico_obrigatorio')}
                                                                    />
                                                                </Col>
                                                                <Col sm={2}>
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        id={`servico_fixo`}
                                                                        name="servico_fixo"
                                                                        label="Serviço fixo"
                                                                        checked={this.state.etapaSelecionada.servico_fixo ? this.state.etapaSelecionada.servico_fixo : false}
                                                                        className="mt-2"
                                                                        onChange={e => this.handleEtapaChangeCheck(e.target.checked, 'servico_fixo')}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </>
                                                        }                                                            
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Col sm={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Ocultar Etapa Para</Form.Label>
                                                    <Row>
                                                        {responsaveisEtapas && Object.entries(responsaveisEtapas).map(([id, label]) => (
                                                            <Col xs={6} sm={2} key={`${id}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                                <Form.Check 
                                                                    type="checkbox"
                                                                    id={`ocultar-${id}`}
                                                                    label={label}
                                                                    checked={this.state.etapaSelecionada.ocultar_etapa ? this.state.etapaSelecionada.ocultar_etapa.includes(id) : false}
                                                                    onChange={e => this.handleOcultarEtapaChange(id, e.target.checked)}
                                                                />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Mídias de Contato</Form.Label>
                                                    <Row>
                                                        {MidiasContato && Object.keys(MidiasContato).map((midia) => (
                                                            <Col xs={6} sm={2} key={`${midia}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                                <Form.Check 
                                                                    type="checkbox"
                                                                    id={`midia-${midia}`}
                                                                    label={MidiasContato[midia]}
                                                                    checked={this.state.etapaSelecionada.midias_contato ? this.state.etapaSelecionada.midias_contato.includes(midia) : false}
                                                                    onChange={e => this.handleMidiasContatoChange(midia, e.target.checked)}
                                                                />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        <Row>
                                        {(this.state.etapaSelecionada.id ? this.state.etapaSelecionada.midias_contato.includes('manuseio')  || this.state.etapaSelecionada.alerta_atendimento : false) && (
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Alerta Navegador</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        name="alerta_navegador" 
                                                        value={this.state.etapaSelecionada.alerta_navegador} 
                                                        onChange={e => this.handleEtapaChange(e)} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                        </Row>
                                        </Row>
                                        {/* Condicionais para exibir mais campos */}
                                        {this.state.etapaSelecionada[0]?.midias_contato?.length > 0 && (
                                            <>  
                                                <Row>
                                                    <Row key={index}>
                                                        <Col sm={3}>
                                                            <Button
                                                                variant="dark"
                                                                size="sm"
                                                                className="mb-2"
                                                                onClick={() => this.abrirModalTemplates(this.state.etapaSelecionada)}
                                                            >
                                                                Templates Whatsapp para Envio Manual
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Configurar mensagens</Form.Label>
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Dias para enviar mensageria</Form.Label>
                                                                    <Form.Control type="number" name="dias_envio_mensageria" value={this.state.etapaSelecionada.dias_envio_mensageria} onChange={e => this.handleEtapaChange(e)}>
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Envia mensageria via cron?</Form.Label>
                                                                    <Form.Control
                                                                        as="select"
                                                                        name="envia_mensageria_cron"
                                                                        value={this.state.etapaSelecionada.envia_mensageria_cron ? "1" : "0"}
                                                                        onChange={e => this.handleSimNaoChange(e, 'envia_mensageria_cron')}
                                                                    >
                                                                        <option key="0" value="0">Não</option>
                                                                        <option key="1" value="1">Sim</option>
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Row>
                                                                {Object.keys(tiposMensagem).map((tipo) => (
                                                                    <Col xs={6} sm={2} key={`${tipo}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                                        <Button
                                                                            type="button"
                                                                            id={`tipo-${tipo}`}
                                                                            label={tiposMensagem[tipo]}
                                                                            onClick={() => this.handleTiposMensagemChange(tipo)}
                                                                            className={`custom-btn-outline-primary ${this.state.etapaSelecionada.tipo_mensagem === tipo ? 'active' : ''}`}
                                                                        >
                                                                            {tiposMensagem[tipo]}
                                                                        </Button>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {this.state.etapaSelecionada.tipo_mensagem === 'padrao' && (
                                                    <>
                                                        {this.state.etapaSelecionada.midias_contato.includes('whatsapp') && (
                                                        <Row>
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>ID do Template do Whatsapp</Form.Label>
                                                                    <Form.Control 
                                                                        type="text" 
                                                                        name="whatsapp_template" 
                                                                        value={this.state.etapaSelecionada.whatsapp_template} 
                                                                        onChange={e => this.handleEtapaChange(e, 'whatsapp_template')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        )}
                                                        <Row>
                                                            <Col sm={3}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Tipo do Envio</Form.Label>
                                                                    <Form.Control as="select" name="tipo_envio" value={this.state.etapaSelecionada.tipo_envio} onChange={e => this.handleEtapaChange(e, 'tipo_envio')}>
                                                                        <option value="">Selecione o tipo de envio</option>
                                                                        {Object.entries(tiposEnvio).map(([value, label]) => (
                                                                            <option key={value} value={value}>{label}</option>
                                                                        ))}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Momento do Envio</Form.Label>
                                                                    <Form.Control as="select" name="momento_envio" value={this.state.etapaSelecionada.momento_envio} onChange={e => this.handleEtapaChange(e, 'momento_envio')}>
                                                                        <option value="">Selecione o momento do envio</option>
                                                                        {Object.entries(momentosEnvio).map(([value, label]) => (
                                                                            <option key={value} value={value}>{label}</option>
                                                                        ))}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Destinatário da Mensagem</Form.Label>
                                                                    <Form.Control as="select" name="destinatario_mensagem" value={this.state.etapaSelecionada.destinatario_mensagem} onChange={e => this.handleEtapaChange(e, 'destinatario_mensagem')}>
                                                                        <option value="">Selecione o destinatário</option>
                                                                        {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                            <option key={value} value={value}>{label}</option>
                                                                        ))}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Conteúdo do SMS</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="conteudo_mensagem"
                                                                        value={this.state.etapaSelecionada.conteudo_mensagem}
                                                                        onChange={e => this.handleEtapaChange(e, 'conteudo_mensagem')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Conteúdo do E-mail</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="conteudo_mensagem_email"
                                                                        value={this.state.etapaSelecionada.conteudo_mensagem_email}
                                                                        onChange={e => this.handleEtapaChange(e, 'conteudo_mensagem_email')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                
                                                {this.state.etapaSelecionada.tipo_mensagem === 'retorno' && (
                                                    <>
                                                        {this.state.etapaSelecionada.midias_contato.includes('whatsapp') && (
                                                        <Row>
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Retorno Whatsapp Template</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="cancelamento_retorno_whatsapp_template"
                                                                        value={this.state.etapaSelecionada.cancelamento_retorno_whatsapp_template}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_retorno_whatsapp_template')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        )}
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Retorno Destinatário da Mensagem</Form.Label>
                                                                    <Form.Control as="select" name="cancelamento_retorno_destinatario_mensagem" value={this.state.etapaSelecionada.cancelamento_retorno_destinatario_mensagem} onChange={e => this.handleEtapaChange(e, 'cancelamento_retorno_destinatario_mensagem')}>
                                                                        <option value="">Selecione o destinatário</option>
                                                                        {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                            <option key={value} value={value}>{label}</option>
                                                                        ))}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Retorno Conteúdo da Mensagem (SMS)</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="cancelamento_retorno_conteudo_mensagem"
                                                                        value={this.state.etapaSelecionada.cancelamento_retorno_conteudo_mensagem}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_retorno_conteudo_mensagem')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Retorno Título do Email</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="cancelamento_retorno_titulo_email"
                                                                        value={this.state.etapaSelecionada.cancelamento_retorno_titulo_email}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_retorno_titulo_email')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Retorno Conteúdo Mensagem do Email</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="cancelamento_retorno_conteudo_mensagem_email"
                                                                        value={this.state.etapaSelecionada.cancelamento_retorno_conteudo_mensagem_email}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_retorno_conteudo_mensagem_email')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {this.state.etapaSelecionada.tipo_mensagem === 'cancelamento' && (
                                                    <>
                                                        {this.state.etapaSelecionada.midias_contato.includes('whatsapp') && (
                                                        <Row>
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Cancelamento Whatsapp Template</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="cancelamento_whatsapp_template"
                                                                        value={this.state.etapaSelecionada.cancelamento_whatsapp_template}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_whatsapp_template')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        )}
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Cancelamento Destinatário da Mensagem</Form.Label>
                                                                    <Form.Control as="select" name="cancelamento_destinatario_mensagem" value={this.state.etapaSelecionada.cancelamento_destinatario_mensagem} onChange={e => this.handleEtapaChange(e, 'cancelamento_destinatario_mensagem')}>
                                                                        <option value="">Selecione o destinatário</option>
                                                                        {Object.entries(destinatariosMensagem).map(([value, label]) => (
                                                                            <option key={value} value={value}>{label}</option>
                                                                        ))}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Cancelamento Conteúdo da Mensagem (SMS)</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="cancelamento_conteudo_mensagem"
                                                                        value={this.state.etapaSelecionada.cancelamento_conteudo_mensagem}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_conteudo_mensagem')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Cancelamento Título do Email</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="cancelamento_titulo_email"
                                                                        value={this.state.etapaSelecionada.cancelamento_titulo_email}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_titulo_email')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Cancelamento Conteúdo Mensagem do Email</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="cancelamento_conteudo_mensagem_email"
                                                                        value={this.state.etapaSelecionada.cancelamento_conteudo_mensagem_email}
                                                                        onChange={e => this.handleEtapaChange(e, 'cancelamento_conteudo_mensagem_email')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                            </>
                                        )}
                            </Card.Body>               
                        </Card>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalEtapas}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={() => this.handleSalvarEtapa()}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            )}
            </>
        );
    }
}

export default EtapasPrograma;

